import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8.487 21h7.026a4 4 0 0 0 3.808 -5.224l-1.706 -5.306a5 5 0 0 0 -4.76 -3.47h-1.71a5 5 0 0 0 -4.76 3.47l-1.706 5.306a4 4 0 0 0 3.808 5.224","key":"svg-0"}],["path",{"d":"M15 3q -1 4 -3 4t -3 -4l6 0","key":"svg-1"}],["path",{"d":"M12 14h-3","key":"svg-2"}],["path",{"d":"M14 11.172a3 3 0 1 0 0 5.656","key":"svg-3"}]]

const IconTaxEuro = createReactComponent('outline', 'tax-euro', 'TaxEuro', __iconNode);

export default IconTaxEuro;